module.exports = __webpack_public_path__ + "img/skoda.daf0010f.webp";